import { UserInfo } from "src/store/reducers/userInfo";

export type UserInfoActions = UpdateAnnualEstimatedIncomeAction;

export enum UserInfoActionTypes {
    UPDATE_ANNUAL_ESTIMATED_INCOME = "UPDATE_ANNUAL_ESTIMATED_INCOME",
}
export interface UpdateAnnualEstimatedIncomeAction {
    data: UserInfo["annualEstimatedIncome"];
    type: UserInfoActionTypes.UPDATE_ANNUAL_ESTIMATED_INCOME;
}

export const updateAnnualEstimatedIncome = (
    data: UserInfo["annualEstimatedIncome"]
): UpdateAnnualEstimatedIncomeAction => ({
    data,
    type: UserInfoActionTypes.UPDATE_ANNUAL_ESTIMATED_INCOME,
});
